module.exports = __webpack_public_path__ + "static/media/MD_TutorialSlides_10202020_20_Settings.d3c63084.png";